import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './VmcMachining.css';

const VmcMachining = () => {
    const [activeFaq, setActiveFaq] = useState(0);
    const navigate = useNavigate();
    const goToContact = () => navigate('/contact', { state: { scrollToForm: true } });

    const faqs = [
        {
            q: "What materials can you machine in VMC?",
            a: "We machine mild steel, stainless steel, aluminum, brass, copper, and engineering alloys."
        },
        {
            q: "What tolerance levels can you maintain?",
            a: "We maintain tight tolerances depending on component requirements and specifications."
        },
        {
            q: "Do you handle bulk production?",
            a: "Yes, we support both prototype development and high-volume production runs."
        }
    ];

    return (
        <div className="vmc-machining-page">
            {/* Hero Section */}
            <section className="vmc-hero">
                <div className="container">
                    <h1 className="fade-in">Precision VMC Machining Services</h1>
                </div>
            </section>

            {/* About VMC section */}
            <section className="vmc-about-section section-padding">
                <div className="container">

                    <div className="vmc-about-header">
                        <div className="vmc-about-title-group">
                            <div className="vmc-icon-wrapper">
                                <img src="https://sakthivel.ascentbw.com/Files/About/About2.png" alt="VMC Icon" onError={(e) => { e.target.onerror = null; e.target.src = "https://sakthivel.ascentbw.com/Files/About/About1.png"; }} />
                            </div>
                            <h2>About Our VMC Machining</h2>
                        </div>

                        <div className="vmc-about-header-split">
                            <div className="vmc-about-header-text">
                                <p>Sakthivel Engineering offers advanced VMC machining services for precision metal components across automotive, industrial, and engineering sectors. Our VMC machines ensure high-speed machining, consistent dimensional accuracy, and excellent surface finish for both small and bulk production.</p>
                            </div>
                            <div className="vmc-about-header-btn">
                                <button className="btn-primary" onClick={goToContact}>Request a Quote</button>
                            </div>
                        </div>
                    </div>

                    <div className="vmc-capabilities-group">
                        <div className="vmc-capability-block">
                            <h3>Our VMC Machining Capabilities</h3>
                            <p>We provide high-precision vertical machining solutions using modern VMC equipment capable of handling complex geometries and tight tolerances.</p>
                            <p className="mt-20">Our capabilities include:</p>
                            <ul className="vmc-capabilities-list mt-10">
                                <li>• 3-Axis & Multi-Axis VMC Machining</li>
                                <li>• High-Speed Milling Operations</li>
                                <li>• Precision Slotting & Pocketing</li>
                                <li>• Surface Finishing & Profiling</li>
                                <li>• Prototype & Production Runs</li>
                            </ul>
                        </div>

                        <div className="vmc-capability-block mt-40">
                            <h3>Our VMC Machining Services Include</h3>
                            <p>We deliver customized VMC machining solutions tailored to your component specifications and production requirements.</p>
                        </div>
                    </div>

                    <div className="vmc-about-img mt-40">
                        <img src="https://sakthivel.ascentbw.com/Files/Service/Sub2.png" alt="VMC Machining Process" onError={(e) => { e.target.onerror = null; e.target.src = "https://sakthivel.ascentbw.com/Files/Service/Sub1.png"; }} />
                    </div>

                    <div className="vmc-quality-block mt-40">
                        <h3>Quality & Process Control</h3>
                        <p className="mt-20">At Sakthivel Engineering, we follow strict inspection and machining standards to maintain consistent production quality.</p>
                        <ul className="vmc-quality-list mt-20">
                            <li>Dimensional inspection using precision tools</li>
                            <li>Surface finish verification</li>
                            <li>Tolerance compliance monitoring</li>
                        </ul>
                    </div>

                </div>
            </section>

            {/* Process Section */}
            <section className="vmc-process-section section-padding bg-light">
                <div className="container">
                    <h2 className="section-title text-center mb-50">Our VMC Machining Process</h2>

                    <div className="process-grid">
                        <div className="process-card">
                            <div className="process-num">01</div>
                            <h5 className="process-accent">Requirement Review</h5>
                            <h4>Requirement Analysis &<br />Planning</h4>
                            <p>We analyze technical drawings, materials, tolerances, and machining feasibility before starting production.</p>
                        </div>
                        <div className="process-card">
                            <div className="process-num">02</div>
                            <h5 className="process-accent">Machining Process</h5>
                            <h4>VMC Machining<br />Execution</h4>
                            <p>Using advanced vertical machining centers, we perform high-precision milling, drilling, and contour machining with strict dimensional control.</p>
                        </div>
                        <div className="process-card">
                            <div className="process-num">03</div>
                            <h5 className="process-accent">Quality & Delivery</h5>
                            <h4>Inspection &<br />Delivery</h4>
                            <p>Each component undergoes thorough inspection to ensure quality standards before timely dispatch.</p>
                        </div>
                    </div>
                </div>
            </section>

            {/* FAQ & Split Section */}
            <section className="vmc-faq-section section-padding bg-light pt-0">
                <div className="container">
                    <div className="vmc-faq-split">

                        <div className="vmc-faq-left">
                            <h5 className="faq-accent">FAQ</h5>
                            <h2 className="section-title text-left">Frequently Asked<br />Questions</h2>
                            <p>Find answers to common questions about our CNC machining services, capabilities, and production process.</p>
                            <button className="btn-primary mt-30" onClick={goToContact}>Request a Quote</button>
                        </div>

                        <div className="vmc-faq-right">
                            <div className="vmc-faq-grid">
                                {faqs.map((faq, idx) => (
                                    <div
                                        key={idx}
                                        className={`vmc-faq-item ${activeFaq === idx ? 'active' : ''}`}
                                        onClick={() => setActiveFaq(activeFaq === idx ? null : idx)}
                                    >
                                        <div className="vmc-faq-header">
                                            <h4>{faq.q}</h4>
                                            <span className="toggle-icon1"></span>
                                        </div>
                                        <div className="vmc-faq-body">
                                            <p>{faq.a}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>

                    </div>
                </div>
            </section>

            {/* CTA Section */}
            <section className="vmc-cta-section">
                <div className="container text-center">
                    <h2>Need Reliable VMC<br />Machining Services?</h2>
                    <p>Submit your component drawings and production requirements. Our team will provide an<br />accurate quotation with reliable delivery timelines.</p>
                    <button className="btn-light mt-30" onClick={goToContact}>Request a VMC Quote</button>
                </div>
            </section>
        </div>
    );
};

export default VmcMachining;
